import type { LANG, SORT_BY } from '@eshop/type'

import i18n from './i18n'
import css from './index.module.css'

interface Props {
    lang: LANG
    setSortBy: (sortBy: SORT_BY) => void
    sortBy: SORT_BY
}

export const ProductSortBy = ({ lang, setSortBy, sortBy }: Props) => {
    const t = i18n[lang]
    return (
        <div className={`r-product-sort-by ${css.container}`}>
            <strong className={css.title}>{t.sortBy}</strong>
            <a
                className={`${css.link} ${sortBy === 'DEFAULT' ? css.active : ''}`.trim()}
                href={void 0}
                onClick={() => setSortBy('DEFAULT')}>
                {t.default}
            </a>
            <a
                className={`${css.link} ${sortBy === 'LOW' ? css.active : ''}`.trim()}
                href={void 0}
                onClick={() => setSortBy('LOW')}>
                {t.priceLow}
            </a>
            <a
                className={`${css.link} ${sortBy === 'HIGH' ? css.active : ''}`.trim()}
                href={void 0}
                onClick={() => setSortBy('HIGH')}>
                {t.priceHigh}
            </a>
        </div>
    )
}
